import React, { useEffect, useState } from 'react'
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LandingNavBar from '../landing-nav-bar/landingNavBar'
import { useNavigate } from 'react-router-dom';
import { APP_CONSTANTS, ROUTES } from '../../../utils/AppConstants';
import { PLAN_PRICING } from '../../../utils/PricingPlan';
import { subscriptionListRequest } from '../../../redux/subscription/subscription.action'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty, isNull, screenCaptureAnalytics } from '../../../utils/Utils';
import { config } from '../../../config';
import PageFooter from '../page-footer/pageFooter';

const PricingPage = props => {
    const [isLoading, setLoading] = useState(false)
    let navigate = useNavigate();
    const { subscriptionListSuccess, subscriptionListError } = useSelector(state => state.subscription)
    const dispatch = useDispatch()

    useEffect(() => {
        if (config.environment === APP_CONSTANTS.ENVIRONMENT.PROD) {
            const data = {
                screen: 'PRICING_PAGE',
                screenClass: 'PRICING_PAGE'
            }
            screenCaptureAnalytics(data)
        }
        setLoading(true)
        const subscriptionPayload = {
            isActive: true,
            productCode: APP_CONSTANTS.PRODUCT_NAME
        }
        dispatch(subscriptionListRequest(subscriptionPayload))
    }, [])

    useEffect(() => {
        if (!isNull(subscriptionListSuccess)) {
            setLoading(false)
        } else if (!isNull(subscriptionListError)) {
            setLoading(false)
        }
    }, [subscriptionListSuccess, subscriptionListError])

    const CheckIcon = () => (
        <svg className="check-icon" viewBox="0 0 24 24">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
        </svg>
    );

    const handleCreateAccountClick = (subscription) => {
        navigate(ROUTES.businessCreateAccount, {
            state: {
                pricingPlan: subscription.subscriptionId
            }
        })
    }

    const getCardClassName = (item) => {
        if (item.isTrailSubscription) {
            return 'pricing-card free-card'
        } else if (!item.isMostFlexible) {
            return 'pricing-card highlighted'
        } else {
            return 'pricing-card'
        }
    }

    return (
        <>
            <LandingNavBar showHomeLink={true} />
            {!isEmpty(subscriptionListSuccess) && <div className="pp-container cu-margin-top">
                <h2 className="lp-title text-center">Pricing That Grows with Ambition – Never Outgrow Us</h2>
                <p className="lp-sub-title text-center">Start with a 1-month free trial (no credit card needed!), then pick a plan that fits your rhythm. All plans include <span className='pp-strong-text'>100% of features</span> – unlimited businesses, granular access controls, and priority support. Pay for 3 or 6 months upfront and focus on growth, not upgrades.</p>
                <div className="cards-grid">
                    {subscriptionListSuccess.data.map(e => (<div className={getCardClassName(e)}>
                        <div className='price-content-container'>
                            {e.isTrailSubscription && <div className="card-badge">Start Free</div>}
                            {e.isMostFlexible && <div className="ribbon">Most Flexible</div>}
                            {!isEmpty(e.savingPercentage) && <div className="card-badge save">Save {e.savingPercentage}</div>}
                            <h3>{e.title}</h3>
                            <div className="price">{e.currencySymbol}{e.price}<small>{e.durationLabel}</small></div>
                            {!e.isTrailSubscription && <div className="billing-note">Billed as {e.currencySymbol}{e.finalPrice} every {e.duration} months</div>}
                            {!isEmpty(e.features) && <ul className="features-list">
                                {e.features.map(item => (<li><CheckIcon /> {item}</li>))}
                            </ul>}
                        </div>
                        <button className={e.isTrailSubscription ? "cta-button free" : 'cta-button'} onClick={() => { handleCreateAccountClick(e) }}>{e.buttonLabel}</button>
                    </div>))}
                    {/* <div className="pricing-card free-card">
                        <div className='price-content-container'>
                            <div className="card-badge">Start Free</div>
                            <h3>1 Month Trial</h3>
                            <div className="price">{PLAN_PRICING.free.currencySymbol}{PLAN_PRICING.free.price}<small>/month</small></div>
                            <ul className="features-list">
                                <li><CheckIcon /> Full Feature Access</li>
                                <li><CheckIcon /> Unlimited Businesses</li>
                                <li><CheckIcon /> Email Support</li>
                            </ul>
                        </div>
                        <button className="cta-button free" onClick={() => { handleCreateAccountClick(PLAN_PRICING.free) }}>Start Free Trial</button>
                    </div> */}
                    {/* 3-Month Plan */}
                    {/* <div className="pricing-card">
                        <div className='price-content-container'>
                            <div className="ribbon">Most Flexible</div>
                            <h3>3 Months</h3> */}
                    {/* <div className="price">$99<small>/month</small></div> */}
                    {/* <div className="price">{PLAN_PRICING.threeMonth.currencySymbol}{PLAN_PRICING.threeMonth.price}<small>/month</small></div> */}
                    {/* <div className="billing-note">Billed as $297 every 3 months</div> */}
                    {/* <div className="billing-note">Billed as {PLAN_PRICING.threeMonth.currencySymbol}{PLAN_PRICING.threeMonth.total} every 3 months</div>
                            <ul className="features-list">
                                <li><CheckIcon /> Everything in Free Trial</li>
                                <li><CheckIcon /> Feature Requests</li>
                                <li><CheckIcon /> Priority Email Support</li>
                            </ul>
                        </div>
                        <button className="cta-button" onClick={() => { handleCreateAccountClick(PLAN_PRICING.threeMonth) }}>Choose 3 Months</button>
                    </div> */}
                    {/* 6-Month Plan */}
                    {/* <div className="pricing-card highlighted">
                        <div className='price-content-container'> */}
                    {/* <div className="card-badge save">Save 20%</div> */}
                    {/* <div className="card-badge save">Save {PLAN_PRICING.sixMonth.savingPercentage}</div>
                            <h3>6 Months</h3> */}
                    {/* <div className="price">$79<small>/month</small></div> */}
                    {/* <div className="price">{PLAN_PRICING.sixMonth.currencySymbol}{PLAN_PRICING.sixMonth.price}<small>/month</small></div> */}
                    {/* <div className="billing-note">Billed as $474 every 6 months</div> */}
                    {/* <div className="billing-note">Billed as {PLAN_PRICING.sixMonth.currencySymbol}{PLAN_PRICING.sixMonth.total} every 6 months</div>
                            <ul className="features-list">
                                <li><CheckIcon /> Everything in 3 Months</li>
                                <li><CheckIcon /> Priority Feature Requests</li>
                                <li><CheckIcon /> Extended Support Hours</li>
                            </ul>
                        </div>
                        <button className="cta-button" onClick={() => { handleCreateAccountClick(PLAN_PRICING.sixMonth) }}>Save with 6 Months</button>
                    </div> */}
                </div>
                <div className="bonus-cta">
                    <p><strong>All plans include:</strong> Unlimited businesses & employees, granular access controls,
                        24/7 support, and all current/future features</p>
                    <p className="cta-text">Only choosing how far ahead you want to plan →</p>
                </div>
            </div>}
            {!isEmpty(subscriptionListError) && <div className='content-error'>{subscriptionListError.message}</div>}
            <PageFooter isPricingPage={true} />
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default PricingPage